import dates from './validations/dates';
import mixed from './validations/mixed';
import strings from './validations/strings';

const valid = value => ({
  valid: true,
  error: undefined,
  value: value,
  reference: undefined
});

const validateField = (field, fieldValidators) => {
  return (fieldValidators || []).reduce((acc, validator) => {
    if (acc.valid) {
      const validation = validator(field);
      if (!validation.valid) {
        return validation;
      }
    }
    return acc;
  }, valid(field));
};

const validate = (object, validators = {}) => {
  return Object.keys(object || {}).reduce((acc, name) => {
    const fieldState = validateField(object[name], validators[name]);
    acc[name] = fieldState;
    return acc;
  }, {});
};

export { mixed, dates, strings, validate, validateField };
